import React, { Component } from 'react';
import TradeHistory from './tradeHistory.jsx'
import MarketPicker from './marketPicker.jsx'

class RightSide extends Component {
  render() {
    return (
      <div className="col m3" >
        <MarketPicker/>
        <TradeHistory/>
      </div>
		)
  }
}

export default RightSide;
